import React from 'react';

const LoadingButton = ({
  loading = false,
  disabled = false,
  children,
  loadingText = 'Loading...',
  className = '',
  variant = 'primary',
  type = 'button',
  onClick,
  ...props
}) => {
  const baseClasses = 'w-full py-3 px-4 rounded-md font-medium transition-colors';
  
  const variantClasses = {
    primary: loading || disabled
      ? 'bg-jet-gray-300 text-jet-gray-500 cursor-not-allowed'
      : 'bg-jet-yellow hover:bg-jet-yellow-hover text-jet-gray-900',
    secondary: loading || disabled
      ? 'border border-jet-gray-200 text-jet-gray-400 cursor-not-allowed'
      : 'border border-jet-gray-300 hover:border-jet-gray-400 text-jet-gray-700'
  };

  return (
    <button
      type={type}
      disabled={loading || disabled}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-jet-gray-600 mr-2"></div>
          {loadingText}
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;